export default function () {
  $('.sponsors__carousel').each(function () {
    const $slider = $(this);

    $slider.on('init', function (event, slick) {
      if ($slider.find('.slick-arrow').length === 0) {
        $slider.addClass('no-slider');
      }
    });

    $slider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1281,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 570,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
}
